"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSessionCookie = exports.getUserInfo = exports.signInWithEmailLink = exports.initEmailLinkAuth = exports.userAuthed = exports.logout = exports.userUnauthed = void 0;

var _types = require("./types");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var userUnauthed = function userUnauthed() {
  return {
    type: _types.USER_UNAUTHED
  };
};

exports.userUnauthed = userUnauthed;

var logout = function logout() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var api;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref.api;
              _context.next = 3;
              return api.logout().then(function () {
                return localStorage.clear();
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.logout = logout;

var userAuthed = function userAuthed(claims) {
  return function (dispatch, getState, _ref3) {
    var api = _ref3.api;
    dispatch({
      type: _types.USER_AUTHED,
      payload: claims
    });

    if (!claims.orgIds || !claims.orgIds.length) {// TODO: Listen to orgs snapshot and either dispatch claims with orgIds or reload app?
    }
  };
};

exports.userAuthed = userAuthed;

var initEmailLinkAuth = function initEmailLinkAuth(email, enqueueSnackbar) {
  return function (dispatch, getState, _ref4) {
    var api = _ref4.api;
    dispatch({
      type: _types.EMAIL_LINK_INIT,
      payload: email
    });
    return api.sendEmailLink(email).catch(function (err) {
      console.error(err);
      enqueueSnackbar(err.message, {
        variant: 'error'
      });
    });
  };
};

exports.initEmailLinkAuth = initEmailLinkAuth;

var signInWithEmailLink = function signInWithEmailLink(email, enqueueSnackbar) {
  return function (dispatch, getState, _ref5) {
    var api = _ref5.api;

    if (api.isSignInWithEmailLink() && email) {
      dispatch({
        type: _types.LOGGING_IN
      });
      return api.loginWithLink(email).catch(function (error) {
        // TODO: Need to remember what this was for
        // TODO: Was this to clear AuthEmail?
        // dispatch({ type: CLEAR_LOGIN });
        console.error(error);
        enqueueSnackbar(error.message, {
          variant: 'error'
        });
      });
    } // TODO: Need to remember what this was for
    // TODO: Was this to clear AuthEmail?
    // return dispatch({ type: CLEAR_LOGIN });


    return false;
  };
};

exports.signInWithEmailLink = signInWithEmailLink;

var getUserInfo = function getUserInfo() {
  return function (dispatch, getState, _ref6) {
    var api = _ref6.api;
    return api.users.getUserInfo(document.domain).then(function (result) {
      // console.log("User IP", result);
      dispatch({
        type: _types.USER_IP_SUCCESS,
        payload: result
      });

      if (result.blockCountry) {
        dispatch({
          type: _types.TOGGLE_BLOCKED_COUNTRY_MESSAGE
        });
      } else if (result.isBlacklisted) {
        dispatch({
          type: _types.TOGGLE_BLACK_LIST_MESSAGE,
          payload: false
        });
      } else if (result.token) {
        return api.loginWithToken(result.token).catch(function (error) {
          console.error(error);
        });
      }
    }).catch(function (err) {
      console.error("failed to get User IP");
    });
  };
};

exports.getUserInfo = getUserInfo;

var createSessionCookie = function createSessionCookie() {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref7) {
      var api;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref7.api;
              return _context2.abrupt("return", api.users.createSessionCookie().catch(function (err) {
                console.error(err);
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4, _x5, _x6) {
      return _ref8.apply(this, arguments);
    };
  }();
};

exports.createSessionCookie = createSessionCookie;